<template>
  <a-row :gutter="10">
    <a-col :span="4">
      <Content @success="setCurrItem"/>
    </a-col>
    <a-col :span="20">
      <List ref="list"/>
    </a-col>
  </a-row>
</template>
<script>
import Content from './content/Index'
import List from './list/Index'
export default {
  components: {
    Content,
    List
  },
  data() {
    return {}
  },
  methods: {
    setCurrItem(item){
      this.$refs.list.setData(item)
    }
  },
}

</script>
<style scoped lang="less">

</style>
